<template>
  <div>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
